import { apiFetch } from "../utils/apiFetch"

export function createPriority(data: any) {
  return apiFetch("/api/priorities", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(data)
  })
}

export function updatePriority(id: string, data: any) {
  return apiFetch(`/api/priorities/${id}`, {
    method: "PUT",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(data)
  })
}

export function deletePriority(id: string) {
  return apiFetch(`/api/priorities/${id}`, { method: "DELETE" })
}

export function getPriorities() {
  return apiFetch("/api/priorities")
}
